import { useCollectPaymentMultiContext } from '../../../collect-payment-multi.context';
import { useTerminalStepJustifiContext } from '../../terminals/terminal-step-context/terminal-step-context-justifi';
import { useTerminalReadersQuery } from '../../terminals/use-terminal-readers-query';
import { CollectTerminalNavigationSwitch } from './collect-terminal-navigation-switch';
import { CollectTerminalStep } from './collect-terminal-step';
import { CollectTerminalStepBodyProps } from './collect-terminal.types';

export const CollectTerminalJustifi = () => {
  return <CollectTerminalNavigationSwitch body={CollectTerminalJustifiBody} />;
};

const CollectTerminalJustifiBody = ({
  onGoBack,
  onCloseWithoutReceipt,
  onInvoiceSent,
  onPaymentSuccess,
}: CollectTerminalStepBodyProps) => {
  const { activeLocationId, invoice } = useCollectPaymentMultiContext();

  const { tempReader, setTempReader, selectedReader, setSelectedReader } = useTerminalStepJustifiContext();

  const locationId = invoice?.locationId || activeLocationId;

  const { readers, refetchReadersAsync, isLoading: isReadersLoading } = useTerminalReadersQuery({ locationId });

  return (
    <CollectTerminalStep
      readers={readers}
      selectedReader={selectedReader}
      isReadersLoading={isReadersLoading}
      onGoBack={onGoBack}
      onInvoiceSent={onInvoiceSent}
      refetchReaders={refetchReadersAsync}
      onPaymentSuccess={onPaymentSuccess}
      setSelectedReader={setSelectedReader}
      tempReader={tempReader}
      setTempReader={setTempReader}
      onCloseWithoutReceipt={onCloseWithoutReceipt}
    />
  );
};
